export var TipoParcelaEnum;
(function (TipoParcelaEnum) {
    TipoParcelaEnum["CONVENCIONAIS"] = "CONVENCIONAIS";
    TipoParcelaEnum["SIGEF"] = "SIGEF";
    TipoParcelaEnum["SNCI"] = "SNCI";
})(TipoParcelaEnum || (TipoParcelaEnum = {}));
(function (TipoParcelaEnum) {
    var mapDescricao = new Map([
        [TipoParcelaEnum.CONVENCIONAIS, 'Desejo utilizar Peças Técnicas Convencionais'],
        [TipoParcelaEnum.SIGEF, 'Desejo utilizar Peças Técnicas do SIGEF'],
        [TipoParcelaEnum.SNCI, 'Desejo utilizar peças técnicas do SNCI – Sistema Nacional de Certificação de Imóveis Rurais'],
    ]);
    function getDescricao(key) {
        return mapDescricao.get(key);
    }
    TipoParcelaEnum.getDescricao = getDescricao;
    function getOptions() {
        var _a, _b, _c;
        return [
            {
                label: (_a = mapDescricao.get(TipoParcelaEnum.SIGEF)) !== null && _a !== void 0 ? _a : '',
                value: TipoParcelaEnum.SIGEF
            },
            {
                label: (_b = mapDescricao.get(TipoParcelaEnum.SNCI)) !== null && _b !== void 0 ? _b : '',
                value: TipoParcelaEnum.SNCI
            },
            {
                label: (_c = mapDescricao.get(TipoParcelaEnum.CONVENCIONAIS)) !== null && _c !== void 0 ? _c : '',
                value: TipoParcelaEnum.CONVENCIONAIS
            },
        ];
    }
    TipoParcelaEnum.getOptions = getOptions;
    function getConvSigefOptions() {
        var list = [];
        mapDescricao.forEach(function (label, value) {
            if (value !== TipoParcelaEnum.SNCI) {
                list.push({ label: label, value: value });
            }
        });
        return list;
    }
    TipoParcelaEnum.getConvSigefOptions = getConvSigefOptions;
    function getScniSigefOptions() {
        var list = [];
        mapDescricao.forEach(function (label, value) {
            if (value !== TipoParcelaEnum.CONVENCIONAIS) {
                list.push({ label: label, value: value });
            }
        });
        return list;
    }
    TipoParcelaEnum.getScniSigefOptions = getScniSigefOptions;
    function getAllOptions() {
        var list = [];
        mapDescricao.forEach(function (label, value) {
            list.push({ label: label, value: value });
        });
        return list;
    }
    TipoParcelaEnum.getAllOptions = getAllOptions;
    function getPecaEnumKey(value) {
        var entry = Object.entries(TipoParcelaEnum).find(function (_a) {
            var _ = _a[0], v = _a[1];
            return v === value;
        });
        return entry ? entry[1] : null;
    }
    TipoParcelaEnum.getPecaEnumKey = getPecaEnumKey;
})(TipoParcelaEnum || (TipoParcelaEnum = {}));
